export default __webpack_public_path__ + "static/hero-desktop-en-daa188302e81b04cf5f5e2d521066b97.png";